import moment from 'moment';
import _ from 'lodash';

import { addDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths } from 'date-fns';

const DATE_FORMAT_DISPLAY = 'MM/DD/YYYY';

export const suitableTime = dateObj => {
  return `${dateObj.hours() < 10 ? `0${dateObj.hours()}` : dateObj.hours()}h${dateObj.minutes() < 10 ? `0${dateObj.minutes()}` : dateObj.minutes()
    }`;
};

export const getDateFormat = (date = new Date(), format = 'L') => {
  return moment(date)
    .locale('fr')
    .format(format);
};
export const getTimeFromNumber = (number = 0) => {
  if (number < 3600)
    return moment()
      .startOf('day')
      .seconds(number)
      .format('mm:ss');
  return moment()
    .startOf('day')
    .seconds(number)
    .format('H:mm:ss');
};
export const calculateAge = date => {
  const birthdate = new Date(date);
  const diffMs = Date.now() - birthdate.getTime();
  const ageDt = new Date(diffMs);
  return Math.abs(ageDt.getUTCFullYear() - 1970);
};

export const getFirstDayQuinzaine = date => {
  return date.get('date') < 16 ? date.set({ date: 1 }) : date.set({ date: 16 });
};
export const getLastDayQuinzaine = date => {
  return date.get('date') < 16 ? date.set({ date: 15 }) : date.endOf('month');
};
export const getMinDate = tab => {
  const firstElement = _.minBy(tab, 'dateOrder');
  return firstElement ? moment(firstElement.dateOrder) : null;
};

export const displayDate = (date, isForOrderModal = false) => {
  if (!date) {
    return '';
  }
  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    return '';
  }
  const formatedDate = momentDate.format(DATE_FORMAT_DISPLAY);
  if (moment().isSame(formatedDate, 'days')) {
    return isForOrderModal
      ? 'Sortie de cuisine prévue pour '
      : ``
  }
  return `${getDateFormat(date)} à `;
};

export const timeDifference = (currentDate, orderDate) => {
  const diff = moment(orderDate).diff(currentDate);
  const m3 = Math.abs(diff);
  const duration = moment.duration(m3);
  const days = parseInt(duration.asDays(), 10);
  const hours = parseInt(duration.asHours(), 10) - days * 24;
  const minutes = parseInt(duration.asMinutes(), 10) - 60 * (days * 24 + hours);
  const seconds = parseInt(duration.asSeconds(), 10) - 60 * (days * 24 + hours + minutes);
  const tab = [`${days}j`, `${hours}h`, `${minutes}min`].filter(
    elt => ![`0j`, `0h`, `0min`].includes(elt)
  );
  return {
    diff,
    diffTime:
      tab.length > 0
        ? tab.reduce((res, k, i) => [res, k].join(i === tab.length - 1 ? ' et ' : ', '))
        : `${seconds}s`
  };
};

export const dateDefaultRanges = {
  today: moment()
    .endOf('day')
    .toDate(),
  startOfWeek: moment()
    .startOf('week')
    .add(1, 'days')
    .toDate(),
  endOfWeek: moment()
    .endOf('week')
    .add(1, 'days')
    .toDate(),
  startOfLastWeek: moment()
    .subtract(7, 'd')
    .startOf('week')
    .add(1, 'days')
    .toDate(),
  endOfLastWeek: moment()
    .subtract(7, 'd')
    .endOf('week')
    .add(1, 'days')
    .toDate(),
  lastSevenDays: moment()
    .subtract(6, 'd')
    .startOf('day')
    .toDate(),
  lastFourWeeks: moment()
    .subtract(27, 'd')
    .startOf('day')
    .toDate(),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1))
};

export const getInitialDateRange = () => {
  const dateRange = {
    startDate: dateDefaultRanges.lastSevenDays,
    endDate: dateDefaultRanges.today,
    key: 'selection'
  };
  return dateRange;
};
export const parseDate = (startDate, endDate) => {

  return startDate && endDate ? `${moment(startDate)
    .locale('fr')
    .format('ll')} - ${moment(endDate)
      .locale('fr')
      .format('ll')}` : 'non définie';
};
export const formatDate = (startDate, endDate) => {
  const startOfDay = moment(startDate).startOf('day').toDate();
  const startWithTime = moment(startOfDay).toDate();
  startDate = startWithTime;
  const endOfDay = moment(endDate).endOf('day').toDate();
  const endWithTime = moment(endOfDay).toDate();
  endDate = endWithTime;
  const formattedStartDate = moment(startDate).format();
  const formattedEndDate = moment(endDate).format();
  return { formattedStartDate, formattedEndDate }

}

export const isHotlineAvailable = (hotlineAvailability) => {
  if (!hotlineAvailability) return false;

  const now = moment();
  const currentDay = now.format('dddd');
  const currentTime = now.hours() * 60 + now.minutes();

  const daySchedule = hotlineAvailability[currentDay];

  if (!daySchedule) return false;

  return daySchedule.slots.some(slot => {
    const [start, end] = slot.split('-');

    const [startHour, startMinute] = start.split(':').map(Number);
    const startTime = startHour * 60 + startMinute;

    const [endHour, endMinute] = end.split(':').map(Number);
    const endTime = endHour * 60 + endMinute;

    return currentTime >= startTime && currentTime <= endTime;
  });
};
export const toSeconds = (minutes) => minutes * 60;
export const toMinutes = (hours) => hours * 60;
export const toHours = (minutes) => minutes / 60;

export const diffInMinutesExact = (dateA, dateB) => {
  const momentA = moment(dateA).local();
  const momentB = moment(dateB).local();

  const totalMinutesA = toMinutes(momentA.hours()) + momentA.minutes();
  const totalMinutesB = toMinutes(momentB.hours()) + momentB.minutes();

  return totalMinutesA - totalMinutesB;
};
export const subtractFromDate = (date, amount, unit = 'minutes') => {
  if (!date || typeof amount !== 'number') return null;
  return moment(date).subtract(amount, unit);
};